export default __webpack_public_path__ + "static/media/colab1.e98bfb06.png";